import { useState } from 'react';
import React from 'react';
import { Image } from 'antd';
import { LoadingSpinner } from 'components/loading-spinner/loading-spinner';
import { motion } from 'framer-motion';

export interface LoadingImageProps {
  src: string;
  loading: boolean;
}

const LoadingImage: React.FunctionComponent<LoadingImageProps> = ({
  src,
  loading,
}: LoadingImageProps) => {
  const [loaded, setLoaded] = useState<boolean>(false);

  return (
    <div style={{ position: 'relative', minWidth: '320px' }}>
      <motion.div
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1,
          color: loading ? Theme['@white'] : Theme['@primary-color'],
        }}
        key={src}
        animate={{
          opacity: loaded && !loading ? 0 : 1,
        }}
        transition={{ delay: 0.2 }}
      >
        <LoadingSpinner />
      </motion.div>

      <motion.div
        animate={{
          opacity: loaded ? 1 : 0,
        }}
        style={{ minWidth: '320px', minHeight: loaded ? 0 : '200px' }}
      >
        <Image
          src={src}
          width="100%"
          height="100%"
          style={{
            borderRadius: '4px',
          }}
          preview={false}
          onLoad={() => setLoaded(true)}
          key={`${src}_loaded`}
        />
      </motion.div>
    </div>
  );
};

export default LoadingImage;
